import { render } from "./FilterTurmas.vue?vue&type=template&id=29155a9c&scoped=true"
import script from "./FilterTurmas.vue?vue&type=script&lang=js"
export * from "./FilterTurmas.vue?vue&type=script&lang=js"

import "./FilterTurmas.vue?vue&type=style&index=0&id=29155a9c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29155a9c"]])

export default __exports__